import { Box, Title } from "@mantine/core";
import { SubmitPage } from "./components/SubmitPage";
import { RatePage } from "./components/RatePage";
import { SuccessPage } from "./components/SuccessPage";

// TODO fix types
export const GRSView = ({ functions, objects }: any) => {
  const { rateData, submitData } = objects;

  return (
    <Box mt="xl" p="xl">
      {/* <MainAppBar /> */}
      <Title align="center" order={2}>
        Global Rating Scale for {objects.currentModuleName}
      </Title>
      {objects.page === 1 ? (
        <SubmitPage
          setScore={functions.setScore}
          data={submitData}
          totalScore={objects.totalScore}
          maxScore={objects.maxScore}
          traineeId={objects.traineeId}
          next={functions.goToSuccess}
          back={functions.goToRate}
        />
      ) : objects.page === 2 ? (
        <SuccessPage end={functions.backToGrsMenu} />
      ) : objects.page === 0 ? (
        <RatePage
          setScore={functions.setScore}
          data={rateData}
          totalScore={objects.totalScore}
          maxScore={objects.maxScore}
          next={functions.goToSubmit}
          setComment={functions.setComment}
          setTraineeId={functions.setTraineeId}
          traineeId={objects.traineeId}
          scores={objects.scores}
          comments={objects.comments}
          leave={functions.backToGrsMenu}
          disableInput={objects.disableInput}
        />
      ) : (
        <></>
      )}
    </Box>
  );
};
